module.exports = __webpack_public_path__ + "static/media/diseno.260ffc9c.jpg";